import React, { Component } from "react";
import { Link } from "react-router-dom";

import { generalS } from "../../strings/general";
import { baseStyles } from "../baseStyles";
import LoadingScreen from "react-loading-screen";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import AOS from 'aos';
import {
  getDaysInMonth, monthNames, daysName, getPostsByLanguage
} from "../general_functions/general";
import CalenderManager from "./CalenderManager";
import LatestProject from "./LatestProject";
import LatestNewsAndEvents from "./LatestNewAndEvents";
import HomeSlider from "./HomeSlider";

import 'aos/dist/aos.css';
import "../../styles/css/home.css";
import "../../styles/css/main.css";
import { url } from '../../inv';

class HomeMain extends Component {
  constructor(props) {
    super(props);
    this.state = { month: 0, year: 2010 }
    AOS.init({ duration: 1200 });
  }

  render() {
    let { context, lpObjs, latestEvents, calender, homeAlbum,
      homeImageDivider, footerText, latestProjects } = this.props;
      console.log(latestProjects)
    let { month, year } = this.state;
    let { language, windowWidth } = context;
    return (
      <div style={{ height: "100%" }}>
        {/* <Header context={context} /> */}
        <div className={"home-album"}>
          <HomeSlider homeAlbum={homeAlbum} windowWidth={windowWidth} />
        </div>

        <div className={"home-calender-title"}>
          <span>
            {generalS.product[language]}
          </span>
        </div>
        <div className={"wrapper"}>
          <LatestProject
            lpObjs={lpObjs}
            windowWidth={windowWidth}
            language={language} />
        </div>
        {homeImageDivider && homeImageDivider.length > 0 ?
          <div style={{
            position: "relative",
            backgroundImage: `url(${url}/public/${homeImageDivider[0].fileNames[0]})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            height: '240px',
            display: 'flex',
            justifyContent: 'center',
          }}></div>
          : ("")
        }

        <div className={"wrapper"}>
          <div className={"home-calender-title"}>
            {latestProjects && latestProjects.length > 0 ?
              generalS.latestNewsAndEvents[language]
              : ("")}
          </div>
          <LatestNewsAndEvents
            windowWidth={windowWidth}
            language={language} latestEvents={latestProjects} />
        </div>
        {/* <div className={"wrapper"}>
          <div className={"home-calender-title"}>
            <span>
              {`${generalS.calender[language]}`}
            </span>
          </div>
          <div className={"home-calender-content"}>
            <CalenderManager
              days={daysName}
              language={language}
              calender={calender}
              titleHandler={(month, year) => {
                this.setState({ month, year });
              }}
              windowWidth={windowWidth} />
          </div>
        </div> */}
        <div className={"wrapper"}>
          <Footer context={context} footerText={footerText} />
        </div>
      </div>
    );
  }
}

export default HomeMain;
